import { Component, OnInit, ViewEncapsulation, forwardRef, ElementRef, Renderer, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl } from '@angular/forms';
import { BaseAbstractControl, UploaderSettings } from 'moh-package';

@Component({
  selector: 'moh-survivors-deceased',
  templateUrl: './survivors-deceased.component.html',
  styleUrls: ['./survivors-deceased.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SurvivorsDeceasedComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => SurvivorsDeceasedComponent) }]
})

export class SurvivorsDeceasedComponent extends BaseAbstractControl implements OnInit {


  deathNoticeDocumentSettings: UploaderSettings = new UploaderSettings();
  deathCertificateDocumentSettings: UploaderSettings = new UploaderSettings();

  constructor(injector: Injector) {

    super(injector);
  }

  ngOnInit() {

    this.initializeFormGroup();

    this.initializeDocumentSettings();
    
    super.ngOnInit();
  }

  initializeFormGroup() {

    this.baseAbstractControl = new FormGroup({
      FirstName: new FormControl('', []),
      LastName: new FormControl('', []),
      IDNumber: new FormControl('', []),
      FathersName: new FormControl('', []),
      DateOfDeath: new FormControl(new Date(), []),
      PlaceOfDeath: new FormControl('', []),
      DeathNoticeDocument: new FormControl('', []),
      DeathCertificateDocument: new FormControl('', [])
    });
  }

  initializeDocumentSettings() {

    this.deathNoticeDocumentSettings = {

      allowMimeTypes: ['application/pdf', 'image/bmp', 'image/gif', 'image/tiff', 'image/jpeg', 'image/png'],
      maxFileSize: 10 * 1024 * 1024, //10MB
      queueLimit: 1,
      queueMinLimit: 1,
      hasDescription: false,
      isDescriptionRequired: false,
      isMultiple: false,
      isRequired: true,
      isSigned: false
    };

    this.deathCertificateDocumentSettings = {

      allowMimeTypes: ['application/pdf', 'image/bmp', 'image/gif', 'image/tiff', 'image/jpeg', 'image/png'],
      maxFileSize: 10 * 1024 * 1024, //10MB
      queueLimit: 1,
      queueMinLimit: 1,
      hasDescription: false,
      isDescriptionRequired: true,
      isMultiple: false,
      isRequired: true,
      isSigned: false
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/survivors/survivors-deceased/survivors-deceased.component.ts